import { render, staticRenderFns } from "./VersionToast.vue?vue&type=template&id=14b4df1a&"
import script from "./VersionToast.vue?vue&type=script&lang=js&"
export * from "./VersionToast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports